import {
  ClassDetailsNoSectionsQuery,
  ClassDetailsNoSectionsQueryVariables,
} from "@outschool/gql-frontend-generated";
import { isUuid } from "@outschool/text";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";
import React from "react";

import * as Routes from "../../../../shared/Routes";
import { ClassDetailsQueryNoSections } from "../subcomponents/ClassDetailsQuery";

export function useClassDetails(activitySlugOrUid: string) {
  const { currentUser } = useSession();
  const [uid, slugId] = isUuid(activitySlugOrUid)
    ? [activitySlugOrUid, undefined]
    : [undefined, Routes.getIdFromSlug(activitySlugOrUid)];
  const esaState = useFundingProgramAbbr();
  const variables: ClassDetailsNoSectionsQueryVariables = React.useMemo(
    () => ({
      uid,
      slugId,
      esaState,
      fundingPrograms: currentUser?.esaMembershipPrograms,
    }),
    [uid, slugId, esaState, currentUser?.esaMembershipPrograms],
  );

  const { error, loading, data } = useQueryWithPreviousData<
    ClassDetailsNoSectionsQuery,
    ClassDetailsNoSectionsQueryVariables
  >(ClassDetailsQueryNoSections, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  return {
    activity: data?.activity,
    error,
    loading,
  };
}
